import React from "react";

// 🔹 Images
import img1 from "../../Assets/10th_lider/Frame (1).png";
import img2 from "../../Assets/10th_lider/Frame (2).png";
import img3 from "../../Assets/10th_lider/Frame.png";
import img4 from "../../Assets/10th_lider/Group.png";
import TopBrand from "./TopBrand";

const WhyCosmicCareness = () => {
  return (
    <>
      <section className="w-full bg-[#F6F7FB] py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">

          {/* 🔹 Heading */}
          <h2 className="text-[24px] sm:text-[28px] md:text-[36px] 
                         font-semibold text-black 
                         text-center md:text-left mb-10">
            Why Cosmic Careness?
          </h2>

          {/* 🔹 Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">

            {/* Item */}
            {[
              {
                img: img1,
                title: "01 Million+",
                desc: "Registered users as of Oct 31, 2024",
              },
              {
                img: img2,
                title: "10 Million+",
                desc: "Orders on Cosmic Careness till date",
              },
              {
                img: img3,
                title: "10,000+",
                desc: "Unique items sold last 6 months",
              },
              {
                img: img4,
                title: "9,000+",
                desc: "Pin codes serviced last 3 months",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="flex flex-col sm:flex-row 
                           items-center sm:items-start 
                           gap-4 text-center sm:text-left"
              >
                <img
                  src={item.img}
                  alt=""
                  className="w-12 h-12 shrink-0"
                />
                <div>
                  <h3 className="text-[18px] md:text-[20px] font-semibold">
                    {item.title}
                  </h3>
                  <p className="text-[13px] md:text-[14px] text-[#8A8A8A] leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      {/* <TopBrand /> */}
    </>
  );
};

export default WhyCosmicCareness;
